(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anaya-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('anaya-carousel')) {
  customElements.define('anaya-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.timer = null;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.visible = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.controls = this.querySelector('.ahc-controls');
      this.pauseButton = this.querySelector('[data-pause-button]');
      this.status = this.querySelector('[data-status]');
      this.dots = this.slides.map((slide, index) => {
        slide.setAttribute('aria-label', `${index + 1} / ${this.slides.length}`);
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${this.dataset.slideLabel} ${index + 1}`);
        button.addEventListener('click', () => this.go(index, true), {signal});
        return button;
      });
      this.querySelector('.ahc-dots').replaceChildren(...this.dots);
      if (!this.slides.length) return;
      this.controls.hidden = this.slides.length < 2 || this.dataset.showControls !== 'true';
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), {signal});
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); this.schedule(); }, {signal});
      this.addEventListener('mouseenter', () => {this.hovered = true; this.schedule();}, {signal});
      this.addEventListener('mouseleave', () => {this.hovered = false; this.schedule();}, {signal});
      this.addEventListener('focusin', () => {this.focused = true; this.schedule();}, {signal});
      this.addEventListener('focusout', (e) => {this.focused = this.contains(e.relatedTarget); this.schedule();}, {signal});
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, {signal});
      const surface = this.querySelector('.ahc-slides');
      let anchor = null;
      let cooldownUntil = 0;
      const resetAnchor = (e) => { anchor = {x:e.clientX,y:e.clientY}; };
      surface.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') resetAnchor(e);
      }, {signal});
      surface.addEventListener('pointerleave', () => { anchor = null; }, {signal});
      surface.addEventListener('pointermove', (e) => {
        if (this.dataset.hoverSlide !== 'true' || e.pointerType !== 'mouse' || this.slides.length < 2) return;
        if (e.buttons !== 0 || this.editorSelected || this.focused ||
            e.target.closest('a,button,input,textarea,select') || performance.now() < cooldownUntil) {
          resetAnchor(e); return;
        }
        if (!anchor) {resetAnchor(e); return;}
        const dx = e.clientX - anchor.x;
        const dy = e.clientY - anchor.y;
        const threshold = Math.max(80, Math.min(140, surface.clientWidth * 0.1));
        if (Math.abs(dy) > 60 && Math.abs(dy) > Math.abs(dx)) {resetAnchor(e);return;}
        if (Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.go(this.index + (dx < 0 ? 1 : -1), true);
          cooldownUntil = performance.now() + 1100;
          resetAnchor(e);
        }
      }, {signal,passive:true});
      window.addEventListener('blur', () => {anchor = null;}, {signal});
      let wheelTotal = 0;
      let wheelLast = 0;
      let wheelLocked = false;
      surface.addEventListener('wheel', (e) => {
        if (e.ctrlKey || this.slides.length < 2 || this.editorSelected) return;
        const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? surface.clientWidth : 1;
        const dx = e.deltaX * unit;
        const dy = e.deltaY * unit;
        if (Math.abs(dx) < 2 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        if (e.cancelable) e.preventDefault();
        const now = performance.now();
        if (now - wheelLast > 220) { wheelTotal = 0; wheelLocked = false; }
        wheelLast = now;
        anchor = null;
        if (wheelLocked) return;
        if (wheelTotal && Math.sign(wheelTotal) !== Math.sign(dx)) wheelTotal = 0;
        wheelTotal += dx;
        if (Math.abs(wheelTotal) < 55) return;
        wheelLocked = true;
        cooldownUntil = now + 750;
        this.go(this.index + (wheelTotal > 0 ? 1 : -1), true);
      }, {signal,passive:false});
      const touchPoint = (touches) => {
        const points = [...touches];
        return {
          x: points.reduce((sum, p) => sum + p.clientX, 0) / points.length,
          y: points.reduce((sum, p) => sum + p.clientY, 0) / points.length,
          spread: points.length === 2 ? Math.hypot(points[0].clientX-points[1].clientX, points[0].clientY-points[1].clientY) : 0
        };
      };
      surface.addEventListener('touchstart', (e) => {
        if (e.touches.length > 2) { this.touch = null; return; }
        const point = touchPoint(e.touches);
        this.touch = {start:point, last:point, count:e.touches.length, cancelled:false};
      }, {signal,passive:true});
      surface.addEventListener('touchmove', (e) => {
        const gesture = this.touch;
        if (!gesture || gesture.cancelled || e.touches.length !== gesture.count) return;
        const point = touchPoint(e.touches);
        gesture.last = point;
        if (gesture.count === 2 && Math.abs(point.spread-gesture.start.spread) > 20) {
          gesture.cancelled = true;
          return;
        }
        const dx = point.x-gesture.start.x;
        const dy = point.y-gesture.start.y;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)*1.5 && e.cancelable) e.preventDefault();
      }, {signal,passive:false});
      surface.addEventListener('touchend', (e) => {
        const gesture = this.touch;
        this.touch = null;
        if (!gesture || gesture.cancelled) return;
        const point = gesture.count === 1 && e.changedTouches.length ? touchPoint(e.changedTouches) : gesture.last;
        const dx = point.x-gesture.start.x;
        const dy = point.y-gesture.start.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)*1.5) {
          cooldownUntil = performance.now()+750;
          this.go(this.index+(dx < 0 ? 1 : -1), true);
        }
      }, {signal,passive:true});
      surface.addEventListener('touchcancel', () => {this.touch = null;}, {signal,passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', (e) => {if(e.matches) this.paused = true; this.sync();this.schedule();}, {signal});
      document.addEventListener('shopify:block:select', (e) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === e.detail.blockId);
        if (index >= 0) {this.editorSelected = true; this.go(index, false);}
      }, {signal});
      document.addEventListener('shopify:block:deselect', () => {this.editorSelected = false;this.schedule();}, {signal});
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;this.schedule();});
      this.observer.observe(this);
      this.go(0, false);
    }
    sync() {
      this.pauseButton.textContent = this.paused ? '▶' : '❚❚';
      this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
    }
    go(index, announce) {
      if (!this.slides.length) return;
      const previous = this.index;
      const next = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      const direction = index < previous ? -1 : 1;
      this.animations?.forEach(animation => animation.cancel());
      this.animations = [];
      this.index = next;
      this.slides.forEach((slide, n) => {
        const active = n === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        this.dots[n].setAttribute('aria-current', String(active));
      });
      if (previous !== next && !this.motion.matches) {
        const outgoing = this.slides[previous];
        const incoming = this.slides[next];
        const options = {duration: 650, easing: 'cubic-bezier(.22,.61,.36,1)'};
        this.animations = [
          outgoing.animate([
            {transform:'translateX(0)',opacity:1,visibility:'visible'},
            {transform:`translateX(${-direction * 100}%)`,opacity:1,visibility:'visible'}
          ], options),
          incoming.animate([
            {transform:`translateX(${direction * 100}%)`},
            {transform:'translateX(0)'}
          ], options)
        ];
      }
      this.querySelector('.ahc-count').textContent = `${String(this.index + 1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
      if (announce) this.status.textContent = `${this.dataset.slideLabel} ${this.index + 1} / ${this.slides.length}`;
      this.sync(); this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editorSelected || document.hidden || !this.visible) return;
      this.timer = setTimeout(() => this.go(this.index + 1, false), Number(this.dataset.delay) || 10000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.animations?.forEach(animation => animation.cancel());
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
